// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lunatone: PokeData = {
  "id": 337,
  "name": "lunatone",
  "height": 10,
  "weight": 1680,
  "base_experience": 161,
  "types": [
    PokeType.ROCK,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "rock-throw",
    "confusion",
    "psychic",
    "hypnosis",
    "harden",
    "psywave",
    "explosion",
    "rock-slide",
    "moonlight",
    "future-sight",
    "cosmic-power",
    "embargo",
    "heal-block",
    "rock-polish",
    "power-gem",
    "stone-edge",
    "psyshock",
    "magic-room",
    "moonblast"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "psychic",
    "psywave",
    "rock-slide",
    "moonlight",
    "future-sight",
    "moonblast",
    "zen-headbutt",
    "rock-blast",
    "kinesis",
    "psy-ball",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 171,
    "item": null,
    "species": [
      {
        "name": "lunatone",
        "order": 365,
        "types": [
          PokeType.ROCK,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 113,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
